import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "a2be1959-bb11-447a-8aad-2466a6ae290c", content: "It is heard as a distinct echo.", options: {} },
  { id: "c0fcc8cb-f828-40ea-a450-b6c3309a5779", content: "It has no audible effect.", options: {} },
  { id: "d44f80ae-8084-43d6-a7b0-4c8c144c2b2a", content: "It creates undesirable<br>tone colouration.", options: {} },
  {
    id: "d3ae417e-cd6f-46d0-9681-8a2342c645e4",
    content: "It increases the apparent<br>loudness of the source.",
    options: {},
  },
];

export const task: Task = {
  id: "2c9c0677-6c0e-4d00-adbe-f339c9b57010",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["d3ae417e-cd6f-46d0-9681-8a2342c645e4"],
};
